import { useState, useEffect } from 'react'
export default function useWpLogo () {
  const [jsonResponse, setPosts] = useState([])
  useEffect(() => {
    let loaded = true
    if (loaded) {
      async function loadPosts (url = '') {
        const fetchUrl = `/wp-json/${url}`
        const response = await fetch(fetchUrl)
        if (!response.ok) {
          // oups! something went wrong
          return
        }

        const posts = await response.json()
        return posts
      }
      loadPosts().then(sitedata => {
        const logoUrl = sitedata?.site_logo ? sitedata?.site_logo : -1
        if (logoUrl > 0) {
          loadPosts(`wp/v2/media?include=${logoUrl}`).then(logodata => {
            if (logodata) {
              setPosts({ sitedata, logodata: logodata[0] })
              return
            }
           
          })
        } 
        setPosts({ sitedata, logodata: undefined })
      })
    }

    return () => {
      loaded = false
    }
  }, [])
  return jsonResponse
}
